import {
  Autocomplete,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { NumberFormatBase } from "react-number-format";
import {
  enleverBaliseHtml,
  formatPhoneNumber,
  isValidEmail,
} from "../../../Helpers/utilsHelper";
import { useQuery } from "../../../hooks/useQuery";
import useToast from "../../../hooks/useToast";
import { AssociationExperienceService } from "../../../service/AssociationExperienceService";
import { DomaineParAMIService } from "../../../service/DomaineParAMIService";
import { uploadService } from "../../../service/UploadService";
import AppButton from "../shares/AppButton";
import AppFileImput from "../shares/AppFileImput";
import StandardSkeletoon from "../shares/loader/StandardSkeletoon";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";

const INIT_EXPERIENCE = {
  id_ext_asso_exp: null,
  id_association: null,
  date_debut: null,
  date_fin: null,
  entreprise: null,
  domaine_exp: null,
  sous_domaine_exp: null,
  statut: null,
  mission: null,
  titre_mission: null,
  reference1: null,
  mail_ref1: null,
  contact_ref1: null,
  file_exp: null,
  fin_contrat: null,
  montant_marche: null,
};
const INIT_FORM_ERROR = {
  date_debut_error: null,
  date_fin_error: null,
  entreprise_error: null,
  domaine_exp_error: null,
  sous_domaine_exp_error: null,
  statut_error: null,
  mission_error: null,
  titre_mission_error: null,
  reference1_error: null,
  montant_marche_error: null,
  mail_ref1_error: null,
  contact_ref1_error: null,
  file_exp_error: null,
  fin_contrat_error: null,
};
const AssociationExperienceForm = ({
  open,
  onFormClose,
  onFormOpen,
  idExperience,
  currentAssociation,
}) => {
  const [currentExperience, setCurrentExperience] = useState(INIT_EXPERIENCE);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [isSubmited, setIsSubmited] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [optionsDomaineCompetence, setOptionsDomaineCompetence] = useState([]);
  const [optionsSousDomaineCompetence, setoptionsSousDomaineCompetence] =
    useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const { Toast, showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const url = useQuery();
  const handleFormClose = () => {
    setFormErrors(INIT_FORM_ERROR);
    setCurrentExperience(INIT_EXPERIENCE);
    setIsSubmited(false);
    onFormClose();
  };

  const handleFetchDomaineCompetence = (filtre) => {
    DomaineParAMIService.lister(filtre).then((res) => {
      if (res && res.data) {
        setOptionsDomaineCompetence(res.data);
      }
    });
    // setOptionsDomaineCompetence(data_domaine);
  };
  const handleFetchSousDomaineCompetence = (filtre) => {
    AssociationExperienceService.getSousDomaineList(filtre).then((res) => {
      if (res && res.data) {
        setoptionsSousDomaineCompetence(res.data);
      }
    });
    // setoptionsSousDomaineCompetence(data_sous_domaine);
  };

  const handleInsertExperience = (experience) => {
    let copy_currentExperience = { ...experience };
    copy_currentExperience.id_association =
      currentAssociation.id_ext_association;
    delete copy_currentExperience.fin_contrat;
    setLoading(true);
    AssociationExperienceService.insert(copy_currentExperience)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleUpdateExperience = (experience) => {
    let exp = { ...experience };
    delete exp.fin_contrat;
    setLoading(true);
    AssociationExperienceService.update(exp)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    setIsSubmited(true);
    const ok = handleCheckError();
    if (ok) {
      if (idExperience) {
        handleUpdateExperience(currentExperience);
      } else {
        handleInsertExperience(currentExperience);
      }
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleFetchExperience = () => {
    if (idExperience) {
      setFormLoading(true);
      AssociationExperienceService.findOneByID(idExperience)
        .then((res) => {
          if (res && res.success) {
            let exp = res.data;
            exp.fin_contrat =
              exp.date_fin === null || exp.date_fin === "0000-00-00 00:00:00"
                ? "Présent"
                : "Non Présent";
            setCurrentExperience(res.data);
          }
        })
        .finally(() => {
          setFormLoading(false);
        });
    } else {
      setCurrentExperience(INIT_EXPERIENCE);
    }
  };

  const handleChangeCurrentExperience = (event) => {
    const { name, value } = event.target;
    setCurrentExperience((prevExperience) => ({
      ...prevExperience,
      [name]: value,
    }));
  };

  const handleCheckError = () => {
    const today = new Date();
    const dateDebut = new Date(currentExperience.date_debut);
    const dateFin = new Date(currentExperience.date_fin);
    setFormErrors({
      date_debut_error: !currentExperience.date_debut
        ? "Date de debut est requise"
        : dateDebut >= today
          ? "Date de debut doit etre au passé"
          : dateDebut > dateFin
            ? "Date de debut doit etre avant la date de fin"
            : null,
      date_fin_error:
        !currentExperience.date_fin &&
        currentExperience.fin_contrat !== "Présent"
          ? "Date de fin est requise"
          : null,
      entreprise_error: !currentExperience.entreprise
        ? "Lieu de travail est requis"
        : null,
      domaine_exp_error: !currentExperience.domaine_exp
        ? "Domaine est requis"
        : null,
      sous_domaine_exp_error: !currentExperience.sous_domaine_exp
        ? "Sous domaine est requis"
        : null,
      statut_error: null,
      mission_error: !currentExperience.mission
        ? "La description de la mission / marché est requise"
        : null,
      titre_mission_error: !currentExperience.titre_mission
        ? "Le titre de la mission / marché est requise"
        : null,
      reference1_error: null,
      mail_ref1_error:
        currentExperience.mail_ref1 &&
        !isValidEmail(currentExperience.mail_ref1)
          ? "Mail est invalide"
          : null,
      contact_ref1_error: String(currentExperience.contact_ref1).length > 10 ? "Numéro de téléphone est invalide" : null,
      file_exp_error: !currentExperience.file_exp
        ? "Certificat de bonne fin requis."
        : uploading
          ? "Telechargement du fichier en cours..."
          : null,
      fin_contrat_error: null,
      montant_marche_error:
        Number(currentExperience.montant_marche) < 1000000 &&
        currentExperience.montant_marche
          ? "Montant de la prestation / marché doit être au moins 1 000 000 MGA"
          : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleFileUpload = (file) => {
    setUploading(true);
    setFormErrors({
      ...formErrors,
      file_exp_error: "Telechargement du fichier en cours...",
    });
    uploadService
      .uploadFile(file)
      .then((res) => {
        if (!(res && res.success)) {
          showToast(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
        }
        setCurrentExperience({
          ...currentExperience,
          file_exp: res && res.success ? res.data.file_name : null,
        });
        /*  setFormErrors({
        ...formErrors,
        file_exp_error:
          res && res.success ? null : enleverBaliseHtml(res.error),
      }); */
      })
      .finally(() => {
        setUploading(false);
      });
  };

  useEffect(() => {
    if (open || idExperience) {
      handleFetchExperience();
      handleFetchDomaineCompetence({ id_type: url.get("job_id") });
      handleFetchSousDomaineCompetence();
    }
  }, [open, idExperience]);

  useEffect(() => {
    if (selectedFile) {
      handleFileUpload(selectedFile);
    }
  }, [selectedFile]);

  useEffect(() => {
    if (currentExperience || uploading) {
      handleCheckError();
    }
  }, [currentExperience, uploading]);

  return (
    <>
      <Toast />
      <Dialog open={open} onClose={handleFormClose} fullScreen>
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid display={formLoading ? "" : "none"}>
            <StandardSkeletoon m={4} col={1} row={4} escalier={true} />
          </Grid>
          <Grid display={!formLoading ? "" : "none"}>
            <CardHeader title="Experience de l'agence / association " />
            <CardContent sx={{ maxHeight: "80vh", overflow: "auto" }}>
              <Grid container>
                <Grid item /* pl={1} pr={1} */>
                  <FormControl fullWidth>
                    <label>Titre de la prestation / marché*</label>
                    <TextField
                      id="titre_mission"
                      name="titre_mission"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      placeholder="Titre de la prestation / marché *"
                      fullWidth
                      value={currentExperience.titre_mission}
                      error={formErrors.titre_mission_error && isSubmited}
                      helperText={
                        isSubmited ? formErrors.titre_mission_error : ""
                      }
                      aria-describedby="titre_mission_helper"
                    />
                    <FormHelperText id="titre_mission_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Date debut</label>
                    <TextField
                      id="date_debut"
                      name="date_debut"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="date"
                      placeholder="Date debut"
                      fullWidth
                      // sx={{
                      //   "& input": {
                      //     textAlign: "right",
                      //   },
                      // }}
                      value={
                        currentExperience.date_debut
                          ? currentExperience.date_debut.slice(0, 10)
                          : ""
                      }
                      error={formErrors.date_debut_error && isSubmited}
                      helperText={isSubmited ? formErrors.date_debut_error : ""}
                      aria-describedby="date_debut_helper"
                    />
                    <FormHelperText id="date_debut_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Date fin *</label>
                    <FormControlLabel
                      // sx={{ mt: 1.5, mb: 2 }}
                      control={
                        <Checkbox
                          checked={currentExperience.fin_contrat === "Présent"}
                          onChange={(evt) => {
                            setCurrentExperience((prev) => ({
                              ...prev,
                              fin_contrat: evt.target.checked
                                ? "Présent"
                                : null,
                              date_fin: !evt.target.checked
                                ? new Date().toISOString().slice(0, 10)
                                : "",
                            }));
                          }}
                          name="fin_contrat"
                        />
                      }
                      label="Nous y travaillons à présent"
                    />
                    <TextField
                      disabled={currentExperience.fin_contrat === "Présent"}
                      id="date_fin"
                      name="date_fin"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="date"
                      placeholder="Année d'obtention du diplôme"
                      fullWidth
                      sx={{
                        /* "& input": {
                          textAlign: "right",
                        }, */
                        display:
                          currentExperience.fin_contrat === "Présent"
                            ? "none"
                            : "",
                      }}
                      value={
                        currentExperience.date_fin
                          ? currentExperience.date_fin.slice(0, 10)
                          : ""
                      }
                      error={formErrors.date_fin_error && isSubmited}
                      helperText={isSubmited ? formErrors.date_fin_error : ""}
                      aria-describedby="date_fin_helper"
                    />
                    <FormHelperText id="date_fin_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Lieu de travail / Client *</label>
                    <TextField
                      id="entreprise"
                      name="entreprise"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      placeholder="Votre lieu de travail / Client *"
                      type="text"
                      fullWidth
                      value={currentExperience.entreprise}
                      error={formErrors.entreprise_error && isSubmited}
                      helperText={isSubmited ? formErrors.entreprise_error : ""}
                      aria-describedby="organisme_helper"
                    />
                    <FormHelperText id="organisme_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Domaine de competence *</label>
                    <Autocomplete
                      // freeSolo
                      name="domaine_exp"
                      id="domaine_exp"
                      options={optionsDomaineCompetence.map(
                        (item) => item.name,
                      )}
                      value={currentExperience.domaine_exp || ""}
                      onChange={(event, newValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "domaine_exp",
                            value: newValue || "",
                          },
                        });
                        handleChangeCurrentExperience({
                          target: {
                            name: "sous_domaine_exp",
                            value: "",
                          },
                        });
                      }}
                      //eviter le saisi libre de l'utilisateur
                      /* onInputChange={(event, newInputValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "domaine_exp",
                            value: newInputValue || "",
                          },
                        });
                      }} */
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          id="domaine_exp"
                          name="domaine_exp"
                          size="small"
                          placeholder="Domaine de competence *"
                          fullWidth
                          error={formErrors.domaine_exp_error && isSubmited}
                          helperText={
                            isSubmited ? formErrors.domaine_exp_error : ""
                          }
                          aria-describedby="domaine_exp_helper"
                        />
                      )}
                    />
                    <FormHelperText id="domaine_competence_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Sous domaine de competence *</label>
                    <Autocomplete
                      // freeSolo
                      name="sous_domaine_exp"
                      id="sous_domaine_exp"
                      options={
                        currentExperience.domaine_exp
                          ? optionsSousDomaineCompetence
                              .filter(
                                (item) =>
                                  (item.id__domaine &&
                                    item.id__domaine ===
                                      optionsDomaineCompetence.find(
                                        (item) =>
                                          item.name ===
                                          currentExperience.domaine_exp,
                                      )?.id_domaine) ||
                                  0,
                              )
                              .map((item) => item.name)
                          : []
                      }
                      value={currentExperience.sous_domaine_exp || ""}
                      onChange={(event, newValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "sous_domaine_exp",
                            value: newValue || "",
                          },
                        });
                      }}
                      //eviter le saisi libre de l'utilisateur
                      /* onInputChange={(event, newInputValue) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "sous_domaine_exp",
                            value: newInputValue || "",
                          },
                        });
                      }} */
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          id="sous_domaine_exp"
                          name="sous_domaine_exp"
                          size="small"
                          placeholder="Sous domaine de competence *"
                          fullWidth
                          error={
                            formErrors.sous_domaine_exp_error && isSubmited
                          }
                          helperText={
                            isSubmited ? formErrors.sous_domaine_exp_error : ""
                          }
                          aria-describedby="sous_domaine_exp_helper"
                        />
                      )}
                    />
                    <FormHelperText id="sous_domaine_exp_helper"></FormHelperText>
                  </FormControl>

                  <FormControl fullWidth>
                    <label>Description de vos missions / marché *</label>
                    <TextField
                      id="mission"
                      name="mission"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="text"
                      multiline
                      rows={4}
                      placeholder="Description de vos mission / Marché *"
                      fullWidth
                      value={currentExperience.mission}
                      error={formErrors.mission_error && isSubmited}
                      helperText={isSubmited ? formErrors.mission_error : ""}
                      aria-describedby="mission_helper"
                    />
                    <FormHelperText id="mission_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Montant de la préstation / marché</label>
                    <NumberFormatBase
                      value={currentExperience.montant_marche}
                      format={(value) =>
                        value.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                      }
                      onValueChange={(values) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "montant_marche",
                            value: values.floatValue,
                          },
                        });
                      }}
                      customInput={TextField}
                      size="small"
                      placeholder="ex: 1 000 000"
                      fullWidth
                      error={formErrors.montant_marche_error && isSubmited}
                      helperText={
                        isSubmited ? formErrors.montant_marche_error : ""
                      }
                      aria-describedby="montant_helper"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              MGA
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                    <FormHelperText id="montant_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>
                      Nom de la personne pour reference à ce poste / réference
                      du marché
                    </label>
                    <TextField
                      id="reference1"
                      name="reference1"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="text"
                      placeholder="Nom complet de la personne referente / réference du marché"
                      fullWidth
                      value={currentExperience.reference1}
                      error={formErrors.reference1_error && isSubmited}
                      helperText={isSubmited ? formErrors.reference1_error : ""}
                      aria-describedby="reference1_helper"
                    />
                    <FormHelperText id="reference1_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Telephone reference</label>
                    <TextField
                      id="contact_ref1"
                      name="contact_ref1"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="tel"
                      placeholder="032 12 345 67"
                      fullWidth
                      value={String(formatPhoneNumber(currentExperience.contact_ref1)).slice(0, 14)}
                      error={formErrors.contact_ref1_error && isSubmited}
                      helperText={
                        isSubmited ? formErrors.contact_ref1_error : ""
                      }
                      aria-describedby="contact_ref1_helper"
                    />
                    {/* <TextField
                      id="telephone"
                      name="telephone"
                      size="small"
                      placeholder="ex: +261 34 00 000 00"
                      fullWidth
                      onChange={(e) =>
                        handleChangeCurrentExperience({
                          target: {
                            name: "contact_ref1",
                            value: e.target.value,
                          },
                        })(e)
                      }
                      aria-describedby="telephone_helper"
                      error={formErrors.telephoneError}
                      helperText={formErrors.telephoneError}
                      value={currentExperience.contact_ref1}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment
                              position="start" 
                            >
                              <Autocomplete
                                fullWidth
                                disableClearable
                                options={InternationalPhoneCode}
                                // getOptionLabel={(option) => `${option.code} (${option.dial_code})`}
                                getOptionLabel={(option) => `${option.code}`}
                                isOptionEqualToValue={(opt, val) =>
                                  opt.code === val.code
                                }
                                value={InternationalPhoneCode.find((item) =>
                                  String(
                                    currentExperience.contact_ref1,
                                  ).startsWith(item.dial_code),
                                )}
                                onChange={(e, newValue) =>
                                  handleChangeCurrentExperience({
                                    target: {
                                      name: "contact_ref1",
                                      value: newValue?.dial_code,
                                    },
                                  })
                                }
                                renderInput={(params) => (
                                  <TextField
                                    fullWidth
                                    {...params}
                                    sx={{
                                      border: "none",
                                      "& .MuiOutlinedInput-root": {
                                        border: "none",
                                        "& fieldset": {
                                          border: "none",
                                        },
                                      },
                                    }}
                                    placeholder="MG"
                                    hiddenLabel
                                    size="small"
                                  />
                                )}
                              ></Autocomplete>
                            </InputAdornment>
                          ),
                        },
                      }}
                    /> */}
                    <FormHelperText id="contact_ref1_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Email reference</label>
                    <TextField
                      id="mail_ref1"
                      name="mail_ref1"
                      onChange={handleChangeCurrentExperience}
                      size="small"
                      type="email"
                      placeholder="Adresse email"
                      fullWidth
                      value={currentExperience.mail_ref1}
                      error={formErrors.mail_ref1_error && isSubmited}
                      helperText={isSubmited ? formErrors.mail_ref1_error : ""}
                      aria-describedby="mail_ref1_helper"
                    />
                    <FormHelperText id="mail_ref1_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Attestation/Certificat de bonne fin</label>
                    <AppFileImput
                      name="file_exp"
                      placeholder={"Attestation / Certificat de bonne fin"}
                      handleFileUpload={(evt) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "file_exp",
                            value: evt.target.files[0]?.name || "",
                          },
                        });
                        setSelectedFile(evt.target.files[0]);
                      }}
                      handleClearFile={(evt) => {
                        handleChangeCurrentExperience({
                          target: {
                            name: "file_exp",
                            value: null,
                          },
                        });
                        setSelectedFile(null);
                      }}
                      file_name={currentExperience.file_exp || ""}
                      allowedFIle={".jpeg,.jpg,.png,.pdf,.docx"}
                      error={formErrors.file_exp_error}
                      helperText={formErrors.file_exp_error}
                    />
                    <FormHelperText id="file_helper"></FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={loading}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={handleSubmit}
              />
              <AppButton
                size={"medium"}
                text={"Fermer"}
                variant={"outlined"}
                onClick={handleFormClose}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default AssociationExperienceForm;
